import { connect } from 'react-redux';
import { getFetchError, getIsLoading, getIsOnline, getPageFromSlug } from 'store/reducers/content';
import { getIsLoggedIn, getIsGigyaLoading } from 'store/reducers/user';
import { getFavoriteStations, getFavoritePodcasts } from 'store/reducers/favorites';
import { MY_JUKE_SLUG } from 'globalConst/const';

import MyJukePage from './MyJukePage';

const mapStateToProps = (state) => ({
  isUserLoggedIn: getIsLoggedIn(state),
  stations: getFavoriteStations(state),
  isLoading: getIsLoading(state) || getIsGigyaLoading(state),
  error: getFetchError(state),
  isOnline: getIsOnline(state),
  podcasts: getFavoritePodcasts(state),
  hasDynamicPage: !!getPageFromSlug(state, MY_JUKE_SLUG),
});

export default connect(mapStateToProps)(MyJukePage);
